<template>
  <div class="w-full bg-white">
    <!-- <div
      class="flex items-center justify-center w-full px-4 pb-8 mt-6 space-x-8 border-b tmsk-blue-border"
    >
      <img
        class="inline-block w-36"
        src="@/assets/img/stay-prepared-logo.svg"
      />
      <img
        class="inline-block cursor-pointer w-28"
        src="@/assets/img/temasek-foundation-logo.svg"
        @click="goToUrl('https://www.temasekfoundation.org.sg')"
      />
    </div> -->
    <div
      class="flex items-center justify-center w-full py-4 space-x-4 text-xs border-t tmsk-blue-text tmsk-blue-border"
    >
      <p
        class="text-center underline cursor-pointer"
        @click="goToUrl('https://stayprepared.sg/staymasked/terms-of-use/')"
      >
        Terms of Use
      </p>
      <p
        class="text-center underline cursor-pointer"
        @click="goToUrl('https://stayprepared.sg/staymasked/accessibility/')"
      >
        Accessibility
      </p>
      <p
        class="text-center underline cursor-pointer"
        @click="goToUrl('https://stayprepared.sg/masks-faq')"
      >
        FAQ
      </p>
      <p
        class="text-center underline cursor-pointer"
        @click="
          goToUrl('https://stayprepared.sg/staymasked/privacy-statement/')
        "
      >
        Privacy Statement
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    goToUrl (url) {
      // window.location.href = url
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
</style>
